import { Button, Switch, Table } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { serverFetch } from '@server';
import { showError, fmtDateTime } from '@extensions/utils';
import { useSelectCompany } from '@extensions/company';
import ResizableDrawer from '@controls/resizable-drawer/resizable-drawer';
import CompanyForm from './company-form';

// Список фирм (только суперадмин)
const Companies = () => {
    const user = useSelector((s) => s.user);
    const selectCompany = useSelectCompany();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editing, setEditing] = useState(null);

    const load = useCallback(() => {
        setLoading(true);
        serverFetch('company')
            .then(setItems)
            .catch(showError)
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => { load(); }, [load]);

    const onSelect = (record) => {
        selectCompany({ id: record.id, name: record.name });
    };

    const onActive = (record, active) => {
        serverFetch(`company/${record.id}/active?active=${active}`, { method: 'PUT' })
            .then(load)
            .catch(showError);
    };

    const openAdd = () => {
        setEditing(null);
        setDrawerOpen(true);
    };

    const openEdit = (record) => {
        serverFetch(`company/${record.id}`)
            .then((c) => {
                setEditing(c);
                setDrawerOpen(true);
            })
            .catch(showError);
    };

    const onSave = (values) => {
        const isEdit = editing && editing.id > 0;
        return serverFetch(isEdit ? `company/${editing.id}` : 'company', {
            method: isEdit ? 'PUT' : 'POST',
            bodyData: isEdit ? values : { ...values, active: true },
        })
            .then((c) => {
                setEditing(c);
                load();
                return c;
            });
    };

    const columns = [
        { title: '#', dataIndex: 'id', width: 50 },
        { title: 'Наименование', dataIndex: 'name' },
        { title: 'Email', dataIndex: 'email' },
        { title: 'Создана', dataIndex: 'createdOn', render: fmtDateTime },
        {
            title: 'Активна',
            dataIndex: 'active',
            render: (v, r) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <Switch checked={v} size="small" onChange={(checked) => onActive(r, checked)} />
                </span>
            ),
        },
        {
            title: '',
            width: 90,
            render: (_, r) => (
                user.companyId === r.id
                    ? <span style={{ color: '#2f6f00' }}>текущая</span>
                    : (
                        <Button size="small" onClick={(e) => { e.stopPropagation(); onSelect(r); }}>
                            Выбрать
                        </Button>
                    )
            ),
        },
    ];

    const isEdit = editing && editing.id > 0;

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <h3 style={{ margin: 0 }}>Фирмы</h3>
                <Button type="primary" icon={<PlusOutlined />} onClick={openAdd} />
            </div>
            <Table
                size="small"
                rowKey="id"
                loading={loading}
                dataSource={items}
                columns={columns}
                onRow={(r) => ({ onClick: () => openEdit(r), style: { cursor: 'pointer' } })}
                pagination={{ pageSize: 20 }}
            />
            <ResizableDrawer
                open={drawerOpen}
                storageKey="companyDrawerWidth"
                defaultWidth={560}
                title={isEdit ? editing.name : 'Новая фирма'}
                onClose={() => setDrawerOpen(false)}
                destroyOnClose
                extra={(
                    <>
                        {isEdit && editing.id !== user.companyId && (
                            <Button size="small" onClick={() => onSelect(editing)}>Выбрать фирму</Button>
                        )}
                        <Button type="text" size="small" icon={<CloseOutlined />} onClick={() => setDrawerOpen(false)} />
                    </>
                )}
            >
                {drawerOpen && (
                    <CompanyForm
                        item={editing}
                        showActive
                        onSave={onSave}
                    />
                )}
            </ResizableDrawer>
        </div>
    );
};

export default Companies;
